import { useParams, useSearchParams } from 'react-router-dom'
import ProjectMapComponent from './ProjectMapComponent'

const ProjectMapContainer = () => {
  const { customerId, localityId, projectId } = useParams()
  const [searchParams] = useSearchParams()

  return (
    <ProjectMapComponent
      customerId={customerId as EntityId}
      localityId={localityId as EntityId}
      projectId={projectId as EntityId}
      height={window.innerHeight}
      fitAllPositions={searchParams.get('fitAll') === 'true'}
    />
  )
}

export default ProjectMapContainer
